// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 6593 ? "framework" : chunkId) + "." + {"4123":"4d761ee0","5178":"ab72ade5","6158":"9c3463e5","6593":"0e4a32a2"}[chunkId] + ".js";
};